<template>
	<div class="meta-grid" v-if="passedProduct">
		<div
				class="row mx-0"
				:style="{ color: product.shippingWeightType != SHIPPING_WEIGHT_TYPE_MARKET ? 'lightgray' : '' }"
		>
			<div class="col-4 px-0">Marktplatz Gewicht</div>
			<div class="col-8 px-0">{{ product.marketWeight }} g</div>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0">Basisgewicht</div>
			<div class="col-8 px-0">{{ product.baseWeight }} g</div>
		</div>

		<div
				class="row mx-0"
				:style="{ color: product.shippingWeightType != SHIPPING_WEIGHT_TYPE_VENDOR ? 'lightgray' : '' }"
		>
			<div class="col-4 px-0">Händler Gewicht</div>
			<div class="col-8 px-0">
				{{ product.vendorWeight }} g
				<span v-if="hasFlag(VENDOR_WEIGHT_AMBIGUOUS)">        (Uneindeutig)
      </span>
			</div>
		</div>

		<div v-if="product.shippingWeightType == 2" class="row mx-0">
			<div class="col-4 px-0">Standardgewicht</div>
			<div class="col-8 px-0">
				<span v-if="hasFlag(VINYL)">400 g</span>
				<span v-else>200 g</span>
			</div>
		</div>

		<div
				class="row mx-0"
				:style="{ color: product.shippingWeightType != SHIPPING_WEIGHT_TYPE_MANUAL ? 'lightgray' : '' }"
		>
			<div class="col-4 px-0 text-nowrap">Manuelles Gewicht</div>

			<div v-if="editWeightState == false" class="col-8 px-0 d-flex">
				<div v-if="manualWeightGUI" class="text-nowrap">
					{{ manualWeightGUI }} g
				</div>

				<span v-else>Manuelles Gewicht hinzufügen</span>

				<div class="px-1">
					<button type="button" class="btn btn-secondary btn-sm mr-1" @click="editWeightState = true">
						<span v-if="manualWeightGUI == null" class="icon icon-plus"></span>
						<span v-else class="icon icon-pencil"></span>
					</button>

					<button
							v-if="manualWeightGUI != null"
							type="button"
							class="btn btn-secondary btn-sm"
							@click="deleteManualWeight()"
					>
						<span class="icon icon-bin"></span>
					</button>
				</div>
			</div>

			<div v-else class="col-8 px-0 d-flex flex-nowrap">
				<div class="input-group input-group-sm mb-auto">
					<input
							type="text"
							class="form-control"
							style="min-width: 50px; max-width: 140px"
							v-model="manualWeightGUI"
							@keypress.13="saveManualWeight()"
					>
					<div class="input-group-append mb-auto">
						<span class="input-group-text">g</span>
					</div>
				</div>

				<div class="px-1">
					<button type="button" class="btn btn-secondary btn-sm" @click="saveManualWeight()">
						<span class="icon icon-checkmark"></span>
					</button>
				</div>

				<div>
					<button type="button" class="btn btn-secondary btn-sm" @click="editWeightState = false">
						<span class="icon icon-cross"></span>
					</button>
				</div>
			</div>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0">Versandaufschlag Flags</div>
			<div class="col-8 px-0" v-html="computedVersandaufschlagList"></div>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0"><b>Versandgewicht</b></div>
			<div class="col-8 px-0">
				<b v-if="product.shippingWeightType == 0">{{ product.shippingWeight }} g (Marktplatz)</b>
				<b v-if="product.shippingWeightType == 1">{{ product.shippingWeight }} g (Händler)</b>
				<b v-if="product.shippingWeightType == 2">{{ product.shippingWeight }} g (Standard)</b>
				<b v-if="product.shippingWeightType == 3">{{ product.shippingWeight }} g (Manuell)</b>
			</div>
		</div>

		<div class="row mx-0" :style="{ color: extraWeightChargeColor }">
			<div class="col-4 px-0">Sonderaufschlag</div>

			<div v-if="editExtraWeightChargeState == false" class="col-8 px-0 d-flex align-items-center">
				<div v-if="extraWeightChargeGUI != null" class="text-nowrap">
					+ {{ extraWeightChargeGUI }} g
				</div>

				<span v-else>Sonderaufschlag hinzufügen</span>

				<div class="px-1">
					<button type="button" class="btn btn-secondary btn-sm" @click="editExtraWeightCharge()">
						<span v-if="extraWeightChargeGUI == null" class="icon icon-plus"></span>
						<span v-else class="icon icon-pencil"></span>
					</button>
				</div>

				<div v-if="extraWeightChargeGUI != null" class="text-nowrap">
					<button type="button" class="btn btn-secondary btn-sm" @click="modalOpenEvent_deleteReason()">
						<span class="icon icon-bin"></span>
					</button>
				</div>
			</div>

			<div v-else class="col-8 px-0 d-flex flex-nowrap">
				<div class="input-group input-group-sm mb-auto">
					<input
							type="text"
							class="form-control"
							style="min-width: 50px; max-width: 140px"
							v-model="extraWeightChargeGUI"
							@keypress.13="modalOpenEvent_addReason()"
					>
					<div class="input-group-append mb-auto">
						<span class="input-group-text">g</span>
					</div>
				</div>

				<div class="pl-1">
					<button type="button" class="btn btn-secondary btn-sm" @click="modalOpenEvent_addReason()">
						<span class="icon icon-checkmark"></span>
					</button>
				</div>

				<div class="pl-1">
					<button type="button" class="btn btn-secondary btn-sm" @click="editExtraWeightChargeState = false">
						<span class="icon icon-cross"></span>
					</button>
				</div>
			</div>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0">Kommentar</div>
			<div class="col-8 px-0">{{ product.extraWeightChargeReason }}</div>
		</div>

		<div v-if="product.calculationWeight != null" class="row mx-0">
			<div class="col-4 px-0"><b>Kalkulationsgewicht</b></div>
			<div class="col-8 px-0"><b>{{ product.calculationWeight }} g</b></div>
		</div>

		<div v-if="product.volumeWeight != null" class="row mx-0">
			<div class="col-4 px-0">Volumengewicht</div>
			<div class="col-8 px-0">{{ product.volumeWeight }} g</div>
		</div>

		<div class="row mx-0 align-items-start">
			<div class="col-4 px-0"><b>Sendungsart Flags</b></div>
			<div class="col-8 px-0"><b>{{ computedSendungsartList }}</b></div>
		</div>

		<!-- Dimensionen - Länge-->
		<div class="row mx-0">
			<div class="col-4 px-0">Länge</div>
			<div class="col-8 px-0">
				<div v-if="product && editDimensionsState == true" class="input-group input-group-sm">
					<input type="text" class="form-control" v-model="product.length">
					<div class="input-group-append mb-auto">
						<span class="input-group-text">cm</span>
					</div>
				</div>

				<div v-else-if="product?.length != null && product?.length != 0">
					{{ product.length }} cm
				</div>
			</div>
		</div>
		<!-- Dimensionen - Breite-->
		<div class="row mx-0">
			<div class="col-4 px-0">Breite</div>
			<div class="col-8 px-0">
				<div v-if="product && editDimensionsState == true" class="input-group input-group-sm">
					<input type="text" class="form-control" v-model="product.width">
					<div class="input-group-append mb-auto">
						<span class="input-group-text">cm</span>
					</div>
				</div>

				<div v-else class="d-flex">
					<div v-if="product && product.width != null && product?.width != 0">
						{{ product.width }} cm
					</div>

					<div class="pl-2">
						<button type="button" class="btn btn-secondary btn-sm" @click="editDimensions()">
							<span class="icon icon-pencil"></span>
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Dimensionen - Höhe-->
		<div class="row mx-0">
			<div class="col-4 px-0">Höhe</div>
			<div class="col-8 px-0">
				<div v-if="editDimensionsState == true" class="input-group input-group-sm">
					<input type="text" class="form-control" v-model="product.height">
					<div class="input-group-append mb-auto">
						<span class="input-group-text">cm</span>
					</div>
				</div>

				<div v-else-if="product.height != null && product.height != 0">
					{{ product.height }} cm
				</div>
			</div>
		</div>

		<div v-if="editDimensionsState == true" class="row mx-0">
			<div class="col-4 px-0"></div>
			<div class="col-8 px-0 d-flex">
				<div class="pr-1">
					<button
							type="button"
							class="input-group-append btn btn-secondary btn-sm input-sm mb-1"
							style="padding-top: 5px"
							@click="saveDimensions()"
					>
						<span class="icon icon-checkmark"></span>
					</button>
				</div>

				<div>
					<button
							type="button"
							class="input-group-append btn btn-secondary btn-sm"
							style="padding-top: 5px"
							@click="editDimensionsState = false"
					>
						<span class="icon icon-cross"></span>
					</button>
				</div>
			</div>
		</div>

		<!-- sonstige Flags -->

		<div class="row mx-0">
			<div class="col-4 px-0">Sonstige Flags</div>
			<div class="col-8 px-0" v-html="computedSonstigeFlagsList"></div>
		</div>

		<!-- vendor dialogue pop-up menu -->
		<div>
			<b-modal v-model="modalState_addReason" centered
							 @ok="saveExtraWeightCharge(false)"
							 ok-title="Bestätigen"
							 @cancel="() => {}"
							 cancel-title="Abbrechen"
							 title="Sonderaufschlag Änderungsgrund"
			><!-- modal -->
				<span>Bitte geben Sie einen Grund an, weswegen der Sonderaufschlag abgeändert wird:</span>
				<textarea type="text" rows=2 class="form-control" style="resize: none" v-model="product.extraWeightChargeReason"></textarea>
			</b-modal>
		</div>

		<!-- dialogue Sonderaufschl. Delete pop-up menu -->
		<div>
			<b-modal v-model="modalState_deleteReason" centered
							 @ok="modalConfirm_deleteReason()"
							 ok-title="Bestätigen"
							 @cancel="() => {}"
							 cancel-title="Abbrechen"
							 title="Sonderaufschlag Änderungsgrund"
			><!-- modal -->
				<span>Bitte geben Sie einen Grund an, weswegen der Sonderaufschlag gelöscht wird:</span>
				<textarea type="text" rows=2 class="form-control" style="resize: none" v-model="product.extraWeightChargeReason">
                    </textarea>
			</b-modal>
		</div>

		<!-- modal Confirm Dialogue -->
		<div><!-- modal Confirm Dialogue -->
			<b-modal v-model="modalConfirm.state" centered
							 @ok="modalConfirmDialogueInput('confirm')"
							 ok-title="Bestätigen"
							 @cancel="modalConfirmDialogueInput('abort')"
							 cancel-title="Abbrechen"
							 :title="modalConfirm.title">
				<p>{{modalConfirm.message}}</p>
			</b-modal>
		</div>

		<div v-if="product">
			<div class="row mx-0" v-if="product.machineMeasurements && product?.machineMeasurements?.length > 0">
				<div class="col-4 px-0"><b>Machinenmaße</b></div>
				<div class="col-8 px-0">
					<machine-measurements-history-table :measurements="product.machineMeasurements"/>
				</div>
			</div>
			<!-- checking if machineProductWeight is set because if one of these fields is set then all should be set  -->
			<div :key="product.id" v-if="product?.machineProductWeight">
				<div class="row mx-0">
					<div class="col-4 px-0">Produktgewicht</div>
					<div class="col-8 px-0">{{ product?.machineProductWeight }} g</div>
				</div>

				<div class="row mx-0">
					<div class="col-4 px-0">Paketgesamtgewicht</div>
					<div class="col-8 px-0">{{ product?.machineTotalWeight }} g</div>
				</div>

        <div class="row mx-0">
          <div class="col-4 px-0">Paketvolumengewicht</div>
          <div class="col-8 px-0">{{ calculateVolumeGramm(product) }} g</div>
        </div>

				<div class="row mx-0">
					<div class="col-4 px-0">Produktlänge</div>
					<div class="col-8 px-0">{{ convertMMtoCM(product?.machineProductLength) }} cm</div>
				</div>

				<div class="row mx-0">
					<div class="col-4 px-0">Produktbreite</div>
					<div class="col-8 px-0">{{ convertMMtoCM(product?.machineProductWidth) }} cm</div>
				</div>

				<div class="row mx-0">
					<div class="col-4 px-0">Produkthöhe</div>
					<div class="col-8 px-0">{{ convertMMtoCM(product?.machineProductHeight) }} cm</div>
				</div>

				<div class="row mx-0">
					<div class="col-4 px-0">Paketlänge</div>
					<div class="col-8 px-0">{{ convertMMtoCM(product?.machinePackageLength) }} cm</div>
				</div>

				<div class="row mx-0">
					<div class="col-4 px-0">Paketbreite</div>
					<div class="col-8 px-0">{{ convertMMtoCM(product?.machinePackageWidth) }} cm</div>
				</div>

				<div class="row mx-0">
					<div class="col-4 px-0">Pakethöhe</div>
					<div class="col-8 px-0">{{ convertMMtoCM(product?.machinePackageHeight) }} cm</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MachineMeasurementsHistoryTable from "../MachineMeasurementsHistoryTable.vue";

export default {
	name: "MeasurementsSection",
	components: {MachineMeasurementsHistoryTable},
	props: {
		passedProduct: {
			type: Object,
			required: true
		},
	},
	data(){
		return {
			product: null,
			modalState_addReason:        false,
			modalState_deleteReason:     false,
			formattedReleaseDate:         null,
			manualWeightGUI: null,
			extraWeightChargeGUI: null,  // for displaying in web page
			extraWeightChargeColor: 'black',
			editExtraWeightChargeState: false,
			editWeightState: false,
			editDimensionsState: false,
			modalConfirm:
					{
						state: false,
						message: 'pre', //TODO: Why pre??
						title: 'Bitte bestätigen',
						callbackFunction: null,
					},
			modalError:
					{
						show: false,
						title: 'Speichern',
						message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.',
						error: '',
					},
			sonstigeFlagsList: null,
			versandaufschlagList: null,
			sendungsartList: null,
			FSK_18: 1n,
			DHL_KLEINPAKET: 2n,            //Sendungsart
			VINYL: 4n,
			BULKY_GOOD: 8n,
			POWER_PLUG: 16n,
			VENDOR_WEIGHT_AMBIGUOUS: 32n,
			VENDOR_WEIGHT_WELTRECORDS: 64n,
			LIQUID: 128n,
			AMIIBO: 256n,            //Versandaufschlag
			SKYLANDERS: 512n,
			FUNKO: 1024n,
			SPRING_PARCEL_US: 2048n,
			CALENDAR: 4096n,
			PARROT: 8192n,
			NINTENDO_GAME: 16384n,
			LITHIUM_BATTERY: 32768n,
			MANUAL_PACKAGE_DIMENSIONS: 65536n,
			POST_NL_LETTERBOX_PLUS:131072n,
			CLAIREFONTAINE: 262144n,
			TPLINK: 524288n,
			MOLESKINE: 1048576n,
			NETGEAR: 2097152n,
			PALADONE: 4194304n,
			OVERSIZED_SPRING: 8388608n,
			CATEGORY_MANUALLY_SET: 16777216n,
			FRAGILE: 33554432n,
			DP_LETTER: 67108864n,
			DP_WARENPOST_DE: 134217728n,
			DP_WARENPOST_INT: 268435456n,
			SPRING_LETTER: 536870912n,
			SPRING_BOXABLE: 1073741824n,
			SHAPE_IRREGULARITY: 2147483648n,
			TRAY: 4294967296n,
			SHIPPING_WEIGHT_TYPE_MARKET: 0,
			SHIPPING_WEIGHT_TYPE_VENDOR: 1,
			SHIPPING_WEIGHT_TYPE_DEFAULT:2,
			SHIPPING_WEIGHT_TYPE_MANUAL: 3,
		}
	},
	watch: {
		passedProduct: {
			immediate: true,
			deep: true,
			handler(newVal) {
				console.warn(newVal);
				if (!newVal) {
					console.warn("passedProduct not ready yet");
					return;
				}
				this.product = newVal;
			}
		}
	},
	computed: {
		computedSendungsartList: function() {
			if(this.product == null) return '';
			let shippingTypeList = [];
			if (this.hasFlag(this.DHL_KLEINPAKET)) 					shippingTypeList.push('DHL Kleinpaket');
			if (this.hasFlag(this.BULKY_GOOD)) 							shippingTypeList.push('Sperrgut');
			if (this.hasFlag(this.OVERSIZED_SPRING)) 				shippingTypeList.push('Oversized Spring');
			if (this.hasFlag(this.DP_LETTER)) 							shippingTypeList.push('Brief');
			if (this.hasFlag(this.DP_WARENPOST_DE)) 				shippingTypeList.push('Warenpost DE');
			if (this.hasFlag(this.DP_WARENPOST_INT)) 				shippingTypeList.push('Warenpost Int.');
			if (this.hasFlag(this.SPRING_LETTER)) 					shippingTypeList.push('Spring Brief');
			if (this.hasFlag(this.SPRING_BOXABLE)) 					shippingTypeList.push('Spring Boxable');
			if (this.hasFlag(this.SPRING_PARCEL_US)) 				shippingTypeList.push('Spring Parcel US');
			if (this.hasFlag(this.POST_NL_LETTERBOX_PLUS)) 	shippingTypeList.push('PostNL Letterbox Plus');


			return _.reduce(shippingTypeList, (sum, x) => { return sum + ((sum == '') ? '' : ', ') + x }, '');
		},
		computedVersandaufschlagList: function() {
			if(this.product == null) return '';
			let additionalCostsList = [];
			if (this.hasFlag(this.VINYL)) 			additionalCostsList.push('+ 300 g Vinyl');
			if (this.hasFlag(this.AMIIBO)) 			additionalCostsList.push('min. 240 g Amiibo');
			if (this.hasFlag(this.SKYLANDERS)) 	additionalCostsList.push('min. 240 g Skylanders');
			if (this.hasFlag(this.FUNKO)) 			additionalCostsList.push('min. 240 g FunKo');
			if (this.product.category === 12) 	additionalCostsList.push('+ 100 g Küche');
			if (this.product.category === 13) 	additionalCostsList.push('+ 100 g Office');
			if (this.hasFlag(this.CALENDAR)) 		additionalCostsList.push('+ 200 g Kalender');
			if (this.hasFlag(this.PARROT)) 			additionalCostsList.push('+ 150 g Parrot');
			if (this.product.category === 8) 		additionalCostsList.push('+ 150 g Beauty');
			if (this.hasFlag(this.FRAGILE)) 		additionalCostsList.push('+ 200 g zerbrechliche Ware');
			return _.reduce(additionalCostsList, (sum, x) => { return sum + ((sum == '') ? '' : '<br>') + x; }, '');
		},
		computedSonstigeFlagsList: function () {
			if(this.product == null) return '';
			let miscFlags = [];
			if (this.hasFlag(this.VENDOR_WEIGHT_AMBIGUOUS)) miscFlags.push('Händler Gewicht uneindeutig');
			if (this.hasFlag(this.NINTENDO_GAME)) 					miscFlags.push('<b>NINTENDO GAME (Block US/CA/MX)</b>');
			if (this.hasFlag(this.LITHIUM_BATTERY)) 				miscFlags.push('Lithium Batterie');
			if (this.hasFlag(this.VINYL)) 									miscFlags.push('Vinyl');
			if (this.hasFlag(this.POWER_PLUG)) 							miscFlags.push('Netzstecker');
			if (this.hasFlag(this.LIQUID)) 									miscFlags.push('Flüssigkeit');
			if (this.hasFlag(this.CLAIREFONTAINE)) 					miscFlags.push('CLAIREFONTAINE (Block US/CA/MX)');
			if (this.hasFlag(this.TPLINK)) 									miscFlags.push('TPLINK (Block)');
			if (this.hasFlag(this.MOLESKINE)) 							miscFlags.push('MOLESKINE (Block)');
			if (this.hasFlag(this.NETGEAR)) 								miscFlags.push('NETGEAR (Block)');
			if (this.hasFlag(this.PALADONE)) 								miscFlags.push('PALADONE (Block)');
			return _.reduce(miscFlags, (sum, x) => { return sum + ((sum == '') ? '' : ', ') + x; }, '');
		},
		newestMeasurement() {
			if (this.product == null) return null;
			const measurements = this.product?.machineMeasurements;

			if (!measurements || measurements.length === 0) {
				return null;
			}
			return [...measurements].sort((a, b) => {
				return new Date(b.date) - new Date(a.date);
			})[0];
		},
	},
	methods: {
		//MM = milimeters / machine measurements
		convertMMtoCM(lengthInMM) {
			if (lengthInMM == null) return null;
			return (lengthInMM / 10).toLocaleString("de-DE");
		},
    calculateVolumeGramm(product) {
      if (!product || !product.machinePackageLength || !product.machinePackageWidth || !product.machinePackageHeight) {
        return null;
      }
      const lengthInCM = product.machinePackageLength / 10;
      const widthInCM = product.machinePackageWidth / 10;
      const heightInCM = product.machinePackageHeight / 10;

      const volumeInCubicCM = lengthInCM * widthInCM * heightInCM;
      const volumeWeight = Math.ceil(volumeInCubicCM / 5000); // Assuming 5000 cubic cm per kg
      return volumeWeight * 1000; // Convert to grams
    },
		hasFlag(flagValue) {
			const flags = BigInt(this.product?.flags ?? 0);
			const bit = BigInt(flagValue);

			return (flags & bit) === bit;
		},
		modalOpenEvent_addReason()
		{
			this.product.extraWeightChargeReason = '';
			this.modalState_addReason = true;
		},

		modalOpenEvent_deleteReason()
		{
			this.modalState_deleteReason = true;
		},

		modalConfirm_deleteReason()
		{
			//this.extraWeightCharge = null;
			this.product.extraWeightCharge = null;
			this.extraWeightChargeGUI = null;
			this.saveExtraWeightCharge(true);
			this.modalState_deleteReason = false;
		},

		editDimensions()
		{
			this.editDimensionsState = true;
		},

		editExtraWeightCharge()
		{
			this.editExtraWeightChargeState = true;
		},

		deleteManualWeight()
		{
			this.modalConfirmDialogue(
					'Wollen Sie das manuelle Gewicht wirklich löschen?',
					() => {
						this.manualWeightGUI = null;
						this.product.manualWeight = null;
						this.save();
					}
			);
		},

		saveManualWeight()
		{
			//if(this.forceNumeric(isNaN(this.manualWeightGUI)))
			if(isNaN(this.forceNumeric(this.manualWeightGUI)))
			{
				this.modalError.title = 'manuelles Gewicht';
				this.modalError.message = "Vorgang abgebrochen: Manuelles Gewicht muss eine Zahl sein.";
				this.modalError.show = true;
			}
			else
			{
				this.product.manualWeight = this.forceNumeric(this.manualWeightGUI);
				this.editWeightState = false;
				try
				{
					this.save();
				}
				catch(error)
				{
					console.log(error);
					this.modalError.error = error.toString();
					this.modalError.message = "Speichervorgang wurde aufgrund eines serverseitigen Fehlers nicht ausgeführt.";
					this.modalError.show = true;

					this.product.setManualWeightUpdateUser = '0';
				}
			}
		},
		saveExtraWeightCharge(isDelete)
		{
			try
			{
				if(isNaN(this.forceNumeric(this.extraWeightChargeGUI)) && !isDelete)
				{
					throw "Gewicht muss eine Zahl sein.";
				}

				this.product.extraWeightCharge = ( this.extraWeightChargeGUI == null ) ? null : this.forceNumeric(this.extraWeightChargeGUI);

				this.editExtraWeightChargeState = false;
				if(!this.saveExtraWeightChargeReason(isDelete)) {
					throw "Kein Sonderaufschlagsgrund angegeben.";
				}
			}
			catch(error)
			{
				console.log(error);
				this.modalError.error = error.toString();
				this.modalError.message = "Der Speichervorgang wurde aufgrund eines serverseitigen Fehlers nicht ausgeführt.";
				this.modalError.show = true;
				this.product.setManualWeightUpdateUser = '0';
			}

			this.save();
		},
		saveExtraWeightChargeReason(isDelete)
		{// when user presses Confirm in modal popup, called by saveExtraWeightCharge()
			//if user wants to delete the extra weight charge, then return true
			if(isDelete) return true;
			//set the setManualWeightUpdateUser flag, so that the user is logged in the metadatabase table (only if a Reason is ever specified).

			this.modalError.error = '';
			if(this.product.extraWeightChargeReason == null || this.product.extraWeightChargeReason == '')
			{
				this.modalError.message = 'Der Speichervorgang wurde wegen fehlendem Userinput nicht ausgeführt: Es wurde kein Änderungsgrund für den Sonderaufschlag angegeben.';
				this.modalError.show = true;
				this.modalState_addReason = false;
				return false;
			}

			if( (this.product.extraWeightChargeReason != null) && (this.product.extraWeightChargeReason.toString().length > 30100) )
			{
				this.modalError.message = 'Achtung: Die Kommentarhistorie des Sonderaufschlags ist für dieses Material größer als 30100 Zeichen angewachsen. Bitte kontaktieren Sie die IT Administration unter Angabe der betroffenen Material ID.';
				this.modalError.show = true;
			}

			if (this.product.extraWeightChargeReason == '' || this.product.extraWeightChargeReason == null)
			{
				this.product.extraWeightChargeReason = '';
			}

			this.modalState_addReason = false;
			return true;
		},
		saveDimensions()
		{
			try
			{
				if( !this.sanityCheckMaybeInt(this.product.length) ||    !this.sanityCheckMaybeInt(this.product.width)
						|| !this.sanityCheckMaybeInt(this.product.height))
				{
					this.modalError.error = '';
					this.modalError.message = "Der Speichervorgang wurde wegen fehelrhaftem Userinput nicht ausgeführt: Die Paketmaße müssen ganzzahlig sein.";
					this.modalError.show = true;
					return false;
				}

				if(this.product.length == null || this.product.length == ''
						|| this.product.width == null    || this.product.width == ''
						|| this.product.height == null || this.product.height == '')
				{
					this.modalError.error = '';
					this.modalError.message = "Der Speichervorgang wurde wegen fehlendem Userinput nicht ausgeführt: Um abspeichern zu können, müssen Länge, Breite und Höhe angegeben werden (in den Feldern -Höhe, Breite, Länge- müssen ganze Zahlen stehen).";
					this.modalError.show = true;
					return false;
				}
				['length', 'width', 'height'].forEach( dim => { this.product[dim] = Number.parseInt(this.product[dim]) });
				// this.product.length = this.product.length; //wtf
				// this.product.width = this.product.width;
				// this.product.height = this.product.height;
				this.editDimensionsState = false;
				console.log(this.product.flags, typeof this.product.flags);
				console.log(this.MANUAL_PACKAGE_DIMENSIONS, typeof this.MANUAL_PACKAGE_DIMENSIONS);
				this.product.flags = BigInt(this.product.flags) | this.MANUAL_PACKAGE_DIMENSIONS;
				this.save();
			}
			catch(error)
			{
				if(error != null)
				{
					console.log(error);
					this.modalError.error = error.toString();
				}
				this.modalError.message = "Der Speichervorgang wurde aufgrund eines serverseitigen Fehlers nicht ausgeführt.";
				this.modalError.show = true;
				this.product.setManualWeightUpdateUser = '0';
			}
			return true;
		},
		save()
		{
			//this.product.materialCategory = this.passedMaterialCategory;
			this.product.manualUpdateOverride = true;

			const payload = {
				...this.product,
				flags: this.product.flags.toString(),
				flagOverrides: this.product.flagOverrides.toString(),
			};

			axios.put('/mds/product', payload)
					.then( response => {
						console.log("updated product");
						console.log(response.data);
						this.product = response.data;
						this.formatReleaseDate();
					}).catch( error => {
            console.log("Error saving dimensions:");
            console.log(error);
            this.modalError = {
              show: true,
              title: 'Speichern',
              message: "Der Speichervorgang konnte aufgrund eines serverseitigen Fehlers nicht ausgeführt werden.",
              error: error.toString()
            };
            this.product.setManualWeightUpdateUser = '0';
            axios.get(`/mds/product/${this.product.asin}`).then( response => {
              console.log("reloaded product");
              console.log(response.data);
              this.product = response.data;
            }).catch( error => console.log(error) );
          });
		},

		forceNumeric(maybeNumeric)
		{
			if(maybeNumeric == null) return null;
			return Number(maybeNumeric.toString().replace(',','.'));
		},

		sanityCheckMaybeInt(x)
		{
			if (typeof x == 'number') {
				return Number.isInteger(x);
			}
			for (let k = 0; k < x.length; k++) {
				if(isNaN(x.charAt(k)))
				{
					return false;
				}
			}
			return true;
		},

		modalConfirmDialogueInput(choice)
		{
			if(choice == 'confirm')
			{
				this.modalConfirm.callbackFunction.call();
			}
			else if (choice != 'abort')
			{
				alert('modalConfirmDialogueInput: unknown input: ' + choice);
			}

			//probably would work best as functor
			this.modalConfirm.state = false;
			this.modalConfirm.message = null;
			this.modalConfirm.callbackFunction = null;

		},
		formatReleaseDate()
		{
			//"Because of the variances in parsing of date strings, it is recommended to always manually parse strings as results are inconsistent, ..."
			// assumes format: YYYY-MM-DD

			if (this.product.releaseDate === null || this.product.releaseDate === "") return;

			let year = this.product.releaseDate.substr(0,4);
			let month = this.product.releaseDate.substr(5,2);
			let day = this.product.releaseDate.substr(8,2);
			this.formattedReleaseDate = day + '.' + month + '.' + year;
		},
		
		modalConfirmDialogue(message, func)
		{
			this.modalConfirm.state = true;
			this.modalConfirm.message = message;
			this.modalConfirm.callbackFunction = func;
		},
	},
	mounted() {
		this.formatReleaseDate();
		this.extraWeightChargeGUI = this.product.extraWeightCharge;
		this.manualWeightGUI = this.product.manualWeight;
	}
}
</script>



<style scoped>
.meta-grid {
	line-height: 2;
	margin-top: -3px;
}

.meta-grid .row {
	align-items: center;
}

.meta-grid .col-4 {
	white-space: nowrap;
}
</style>